import React from 'react';
import PropTypes from 'prop-types';

import Investment from './components/Investment';

import './style.css';

const Home = ({invites}) => (
  <section className="fullPageContainer">
    <h1 styleName="header">Investments</h1>
    <section styleName="list">
      {
        invites && invites.map(invite => (
          <Investment invite={invite} deal={invite.deal} key={invite.id} data-test={invite.id} />
        ))
      }
    </section>
  </section>
);

Home.propTypes = {
  invites: PropTypes.array.isRequired,
};

export default Home;



// WEBPACK FOOTER //
// ./web/flows/home/component.js